import { DEMO_CARD_CAROUSEL } from './fragments/components/demoCardCarousel'
// Hero
import { HERO_SIDE_IMAGE } from './fragments/components/heroSideImage'
import { HERO_SIDE_IMAGE_V2 } from './fragments/components/heroSideImageV2'
import { HERO_SECTION_V1 } from './fragments/components/heroSectionV1'
import { HERO_SECTION_V2 } from './fragments/components/heroSectionV2'
import { HERO_SECTION_V3 } from './fragments/components/heroSectionV3'
import { HERO_SECTION_V4 } from './fragments/components/heroSectionV4'
import { HERO_ANIMATION } from './fragments/components/heroAnimation'
import { HERO_COVER_IMAGE } from './fragments/components/heroCoverImage'
import { HERO_WITH_TEXT } from './fragments/components/heroWithText'
import { HERO_CAROUSEL } from './fragments/components/heroCarousel'
import { HERO_WITH_FORM } from './fragments/components/heroWithForm'
import { HERO_WITH_FORM_DELIGHT } from './fragments/components/heroWithFormDelight'
import { HERO_WITH_FORM_V2 } from './fragments/components/heroWithFormV2'
import { HERO_FEATURE_COLUMNS } from './fragments/components/heroFeatureColumns'
import { HERO_VIDEO_TIMESTAMPS } from './fragments/components/heroVideoTimestamps'
import { HERO_SEASONS_EVENTS } from './fragments/components/heroSeasonsEvents'
import { HERO_WITH_IMAGE_AND_TEXT_CAROUSEL } from './fragments/components/heroWithImageAndTextCarousel'

// Components
import { STATS } from './fragments/components/stats'
import { STATS_DELIGHT } from './fragments/components/statsDelight'
import { LOTTIE } from './fragments/components/lottie'
import { LOGO_GARDEN } from './fragments/components/logoGarden'
import { CTA, CTA_CONTAINED, CTA_COMPACT, CTA_BACKGROUND_IMAGE } from './fragments/components/cta'
import { QUOTE } from './fragments/components/quote'
import { INFORMATION_ACCORDION, ACCORDION_MEDIA, INFORMATION_ACCORDION_DELIGHT } from './fragments/components/accordion'
import { FAQ, FAQ_DELIGHT, FAQ_CENTERED } from './fragments/components/faq'
import { CARD_GRID } from './fragments/components/cardGrid'
import { FEATURE_TABS } from './fragments/components/featureTabs'
import { TEXT_AND_MEDIA } from './fragments/components/textAndMedia'
import { TEXT_AND_MEDIA_DELIGHT } from './fragments/components/textAndMediaDelight'
import { RESOURCES } from './fragments/components/resources'
import { ONEBOARD_GUIDE } from './fragments/components/oneboardGuide'
import { AUTOPLAY_PRODUCT_GUIDE } from './fragments/components/autoplayProductGuide'
import { GROUPED_TEXT_MEDIA_SECTION } from './fragments/components/groupedTextMediaSection'
import { GROUPED_FEATURES } from './fragments/components/groupedFeatures'
import { TEXT_BANNER } from './fragments/components/textBanner'
import { CTA_ADVANCED } from './fragments/components/ctaAdvanced'
import { INTEGRATIONS } from './fragments/components/integrations'
import { COMPARE_TABLES } from './fragments/components/compareTables'
import { QUESTIONS } from './fragments/components/questions'
import { IMAGE_TEXT_STACK } from './fragments/components/imageTextStack'
import { RELEASE_TIMELINE } from './fragments/components/releaseTimeline'
import { ROI_CALCULATOR } from './fragments/components/roiCalculator'
import { ROI_CALCULATOR_V2 } from './fragments/components/roiCalculatorV2'
import { TEXT_MEDIA_MOBILE_SLIDER } from './fragments/components/textMediaMobileSlider'
import { QUOTES_CAROUSEL } from './fragments/components/quotesCarousel'
import { TEXT_AND_MEDIA_EXTENDED } from './fragments/components/textAndMediaExtended'
import { CUSTOM_HTML } from './fragments/components/customHtml'
import { TEXT_AND_IMAGE } from './fragments/components/textAndImage'
import { METRICS_BAR } from './fragments/components/metricsBar'
import { COMPARISON_TABLE } from './fragments/components/comparisonTable'
import { FEATURE_PAGES } from './fragments/components/featurePages'
import { TEXT_FORM } from './fragments/components/textForm'
import { AGENDA_SCHEDULE } from './fragments/components/agendaSchedule'
import { AGENDA_GRID } from './fragments/components/agendaGrid'
import { LOCATION } from './fragments/components/location'
import { CONTENT_INTRO } from './fragments/components/contentIntro'
import { CONTENT_TWO_COLUMN_GRID } from './fragments/components/contentTwoColumnGrid'
import { MULTI_STEP_FORM } from './fragments/components/multiStepForm'
import { MULTI_STEP_FORM_RESULT } from './fragments/components/multiStepFormResult'
import { QUOTE_HIGHLIGHT } from './fragments/components/quoteHighlight'
import { SCORE_BREAKDOWN } from './fragments/components/scoreBreakdown'
import { PILLARS } from './fragments/components/pillars'
import { BENEFITS } from './fragments/components/benefits'
import { HERO_ASSESSMENT } from './fragments/components/heroAssessment'
import { FEATURE_LIST } from './fragments/components/featureList'
import { INDUSTRY_SHOWCASE } from './fragments/components/industryShowcase'
import { FEATURE_GRID } from './fragments/components/featureGrid'
import { CONTEXT_SOURCES } from './fragments/components/contextSources'
import { FEATURE_TILES } from './fragments/components/featureTiles'
import { MEDIA_HIGHLIGHT } from './fragments/components/mediaHighlight'
import { HEADING_TEXT } from './fragments/components/headingText'
import { SCROLL_SHOWCASE } from './fragments/components/scrollShowcase'
import { ANIMATED_TEXT } from './fragments/components/animatedText'
import { ANIMATED_HIGHLIGHT_TEXT } from './fragments/components/animatedHighlightText'
import { BENEFITS_SECTION } from './fragments/components/benefitsSection'
import { HERO_SIMPLE } from './fragments/components/heroSimple'
import { CONTENT_BLOCK } from './fragments/components/contentBlock'
import { OPEN_POSITIONS } from './fragments/components/openPositions'
import { OVERSIGHT_SHOWCASE } from './fragments/components/oversightShowcase'
import { LOTTIE_ANIMATION } from './fragments/components/lottieAnimation'
import { CHAPTER_LIST } from './fragments/components/chapterList'
import { METRICS_AND_TIPS } from './fragments/components/metricsAndTips'
import { METRIC_CARDS } from './fragments/components/metricCards'
import { FEATURE_BLOCK_WITH_VISUAL } from './fragments/components/featureBlockWithVisual'
import { CASE_STUDIES_CAROUSEL } from './fragments/components/caseStudiesCarousel'
import { STAGE_LIST } from './fragments/components/stageList'
import { PERMISSION_AUDIT } from './fragments/components/permissionAudit'
import { QUOTES_CAROUSEL_V2 } from './fragments/components/quotesCarouselV2'
import { AGENDA_GROUPED } from './fragments/components/agendaGrouped'
import { HORIZONTAL_SCROLL_CARDS } from './fragments/components/horizontalScrollCards'
import { METRICS_BAR_V2 } from './fragments/components/metricsBarV2'
import { EXPLORE_CONTENT } from './fragments/components/exploreContent'
import { IMAGE, IMAGE_MOBILE } from './fragments/elements/assets'
import { FORM_POPUP } from './fragments/components/formPopup'
import { BANNER_CONTENT } from './fragments/banner'
import { CARD_WITH_VIDEO } from './fragments/components/cardWithVideo'
import { HISTORY_AND_UPCOMING } from './fragments/components/historyAndUpcoming'
import { RESOURCE_HUB } from './fragments/components/resourceHub'
import { TEAM } from './fragments/components/team'
import { INDUSTRY_BLUEPRINT } from './fragments/components/industryBlueprint'
import { VOICE_DEMO } from './fragments/components/voiceDemo' // Voice Demo Advanced-tab Anchor ID
import { ZENDESK_PRICING_CALCULATOR } from './fragments/components/zendeskPricingCalculator'
import { INDUSTRY_SHOWCASE_CAROUSEL } from './fragments/components/industryShowcaseCarousel'
import { CUSTOMER_STORIES } from './fragments/components/customerStories'
import { USE_CASES_SLIDER } from './fragments/components/useCasesSlider'
import { STATS_MARQUEE } from './fragments/components/statsMarquee'

// The block selections for a page's hero / pageBuilder fields. Exported so the Block Library
// query (queries/block-library.ts) renders library blocks with the exact same fragments.
export const HERO_BLOCKS = `
  __typename

  ${ HERO_SIDE_IMAGE }

  ${ HERO_SIDE_IMAGE_V2 }

  ${ HERO_SECTION_V1 }

  ${ HERO_SECTION_V2 }

  ${ HERO_SECTION_V3 }

  ${ HERO_SECTION_V4 }

  ${ HERO_ANIMATION }

  ${ HERO_COVER_IMAGE }

  ${ HERO_WITH_FORM }

  ${ HERO_WITH_FORM_DELIGHT }

  ${ HERO_WITH_FORM_V2 }

  ${ HERO_WITH_TEXT }

  ${ HERO_CAROUSEL }

  ${ HERO_ASSESSMENT }

  ${ HERO_FEATURE_COLUMNS }

  ${ HERO_VIDEO_TIMESTAMPS }

  ${ HERO_SEASONS_EVENTS }

  ${ HERO_SIMPLE }

  ${ HERO_WITH_IMAGE_AND_TEXT_CAROUSEL }

`

export const PAGE_BUILDER_BLOCKS = `
  ${ DEMO_CARD_CAROUSEL }
  __typename

  ${ LOGO_GARDEN }

  ${ CTA }

  ${ CTA_BACKGROUND_IMAGE }

  ${ LOTTIE }

  ${ FEATURE_TABS }

  ${ HERO_SIDE_IMAGE }

  ${ QUOTE }

  ${ STATS }

  ${ STATS_DELIGHT }

  ${ INFORMATION_ACCORDION }

  ${ ACCORDION_MEDIA }

  ${ INFORMATION_ACCORDION_DELIGHT }

  ${ CARD_GRID }

  ${ FAQ }

  ${ FAQ_DELIGHT }

  ${ FAQ_CENTERED }

  ${ CTA_CONTAINED }

  ${ TEXT_AND_MEDIA }

  ${ TEXT_AND_MEDIA_DELIGHT }

  ${ RESOURCES }

  ${ ONEBOARD_GUIDE }

  ${ AUTOPLAY_PRODUCT_GUIDE }

  ${ GROUPED_TEXT_MEDIA_SECTION }

  ${ GROUPED_FEATURES }

  ${ TEXT_BANNER }

  ${ CTA_ADVANCED }

  ${ HERO_WITH_FORM }

  ${ CTA_COMPACT }

  ${ INTEGRATIONS }

  ${ COMPARE_TABLES }

  ${ QUESTIONS }

  ${ IMAGE_TEXT_STACK }

  ${ RELEASE_TIMELINE }

  ${ ROI_CALCULATOR }

  ${ ROI_CALCULATOR_V2 }

  ${ TEXT_MEDIA_MOBILE_SLIDER }

  ${ QUOTES_CAROUSEL }

  ${ TEXT_AND_MEDIA_EXTENDED }

  ${ CUSTOM_HTML }

  ${ TEXT_AND_IMAGE }

  ${ METRICS_BAR }

  ${ COMPARISON_TABLE }
  
  ${ FEATURE_PAGES }

  ${ TEXT_FORM }

  ${ AGENDA_SCHEDULE }

  ${ AGENDA_GRID }

  ${ LOCATION }

  ${ CONTENT_INTRO }

  ${ CONTENT_TWO_COLUMN_GRID }

  ${ MULTI_STEP_FORM }

  ${ MULTI_STEP_FORM_RESULT }

  ${ QUOTE_HIGHLIGHT }

  ${ SCORE_BREAKDOWN }

  ${ PILLARS }

  ${ BENEFITS }

  ${ FEATURE_LIST }

  ${ INDUSTRY_SHOWCASE }

  ${ FEATURE_GRID }

  ${ HERO_VIDEO_TIMESTAMPS }

  ${ CONTEXT_SOURCES }

  ${ FEATURE_TILES }

  ${ MEDIA_HIGHLIGHT }

  ${ HEADING_TEXT }

  ${ SCROLL_SHOWCASE }
  
  ${ ANIMATED_TEXT }

  ${ ANIMATED_HIGHLIGHT_TEXT }

  ${ BENEFITS_SECTION }

  ${ OVERSIGHT_SHOWCASE }

  ${ LOTTIE_ANIMATION }

  ${ CHAPTER_LIST }

  ${ METRICS_AND_TIPS }

  ${ METRIC_CARDS }

  ${ FEATURE_BLOCK_WITH_VISUAL }

  ${ CASE_STUDIES_CAROUSEL }

  ${ QUOTES_CAROUSEL_V2 }
  
  ${ STAGE_LIST }

  ${ PERMISSION_AUDIT }

  ${ AGENDA_GROUPED }

  ${ HORIZONTAL_SCROLL_CARDS }

  ${ METRICS_BAR_V2 }
  
  ${ CONTENT_BLOCK }

  ${ OPEN_POSITIONS }

  ${ EXPLORE_CONTENT }

  ${ CARD_WITH_VIDEO }

  ${ HISTORY_AND_UPCOMING }

  ${ RESOURCE_HUB }

  ${ TEAM }

  ${ INDUSTRY_BLUEPRINT }

  ${ VOICE_DEMO }

  ${ ZENDESK_PRICING_CALCULATOR }

  ${ INDUSTRY_SHOWCASE_CAROUSEL }

  ${ CUSTOMER_STORIES }

  ${ USE_CASES_SLIDER }

  ${ STATS_MARQUEE }

`

export const PAGE_QUERY = `
query getPage(
  $site: [String]
  $uri: [String]) {
  
  entry(
    section: "pages"
    site: $site
    uri: $uri
  ) {
    title
    id
    dateCreated
    dateUpdated
    postDate

    ...on page_Entry {

      schemaPageType

      secondaryHeaderNavigation {
        children {
          title
          typeHandle

          ... on navItem_Entry {
            linkField {
              url
            }
          }

          ... on navButton_Entry {
            linkField {
              url
            }
          }
            
        }
      }

      ${ FORM_POPUP }

      ${ BANNER_CONTENT }

      overlappingHeader
      overlappingHeaderDark
      headerVisibilityOptions
      hideFooterNavigation
      popupEnabled
      globalCtaTextOverride
      ${ IMAGE }
      ${ IMAGE_MOBILE }
      backgroundColor

      customHeaderCta {
        url
        title
        class
      }
      pageButtonsColor
      
      hero {
       ${ HERO_BLOCKS }
      }
      
      pageBuilder {
       ${ PAGE_BUILDER_BLOCKS }
      }

    }
  }
}
`
